/** Family Calendar client (§22.18) — events CRUD + .ics import. */
import { api } from './client';

export type CalendarKind =
  | 'school'
  | 'sports'
  | 'music'
  | 'activity'
  | 'doctor'
  | 'homework'
  | 'other';

export interface CalendarEvent {
  id: string;
  family_id: string;
  child_id: string | null;
  title: string;
  kind: CalendarKind;
  starts_at: string;
  ends_at: string | null;
  all_day: boolean;
  location_name: string | null;
  place_lat: number | null;
  place_lng: number | null;
  notify_on_arrival: boolean;
  remind_minutes_before: number | null;
  source: 'manual' | 'ics' | 'google';
  created_at: string;
}

export interface CalendarEventCreate {
  title: string;
  kind: CalendarKind;
  starts_at: string;
  ends_at?: string | null;
  all_day?: boolean;
  child_id?: string | null;
  location_name?: string | null;
  notify_on_arrival?: boolean;
  remind_minutes_before?: number | null;
}

export interface IcsImportResult {
  imported: number;
  updated: number;
  skipped: number;
}

const BASE = '/v1/families/me/calendar';

export const calendarApi = {
  events: (daysAhead = 30, childId?: string) => {
    const qs = new URLSearchParams({ days_ahead: String(daysAhead) });
    if (childId) qs.set('child_id', childId);
    return api<CalendarEvent[]>(`${BASE}/events?${qs.toString()}`);
  },
  create: (body: CalendarEventCreate) =>
    api<CalendarEvent>(`${BASE}/events`, { method: 'POST', body }),
  update: (id: string, body: Partial<CalendarEventCreate>) =>
    api<CalendarEvent>(`${BASE}/events/${id}`, { method: 'PATCH', body }),
  remove: (id: string) => api<void>(`${BASE}/events/${id}`, { method: 'DELETE' }),
  importIcs: (ics: string, kind: CalendarKind = 'other', childId?: string) =>
    api<IcsImportResult>(`${BASE}/import-ics`, {
      method: 'POST',
      body: { ics, kind, child_id: childId ?? null },
    }),
};
